import { renderAuthForm } from "./auth.js";
import { t } from "./i18n.js";

/**
 * Landing view for logged-out visitors. Explains what snail is and how to get
 * in, then embeds the Telegram-account login form. Rendered into #main when
 * there's no session; on success the caller reloads into the app. Copy is
 * localized via i18n (the bot stays English).
 */
export function renderLanding(main: HTMLElement, onDone: () => void): void {
  main.innerHTML = `
    <div class="landing">
      <p class="landing-skip"><a href="#auth-form">${t("landing.skip_to_login")}</a></p>

      <section class="landing-hero">
        <img src="/logo.png" class="hero-logo" alt="">
        <h2>snail</h2>
        <p class="landing-tagline">${t("landing.tagline")}</p>
        <p>${t("landing.intro")}</p>
        <p>${t("landing.rhythm")}</p>
      </section>

      <aside class="landing-rule">
        <p>${t("landing.rule.short")}</p>
        <p>${t("landing.rule.long")}</p>
      </aside>

      <p class="landing-manifesto">
        <a href="/manifesto.html">${t("landing.manifesto")}</a>
      </p>

      <section class="landing-how">
        <h3>${t("landing.how.title")}</h3>
        <ol>
          <li>${t("landing.how.take_turns")}</li>
          <li>${t("landing.how.write")}</li>
          <li>${t("landing.how.publishes")}</li>
          <li>${t("landing.how.keeps_nothing")}</li>
        </ol>
      </section>

      <section class="landing-invite">
        <h3>${t("landing.invite.title")}</h3>
        <p>${t("landing.invite.body")}</p>
        <p>${t("landing.invite.email")}</p>
      </section>

      <section class="landing-signin">
        <h3>${t("landing.signin.title")}</h3>
        <p class="landing-signin-note">${t("landing.signin.note")}</p>
        <div id="auth-form"></div>
      </section>
    </div>`;

  renderAuthForm(main.querySelector<HTMLElement>("#auth-form")!, onDone);
}
